import type { ReminderState } from '../../lib/reminders'

interface Props { state: ReminderState }

function ProgressBar({ value, status }: { value: number; status: string }) {
  const color = status === 'overdue' ? '#d32f2f' : status === 'warning' ? '#f57c00' : '#388e3c'
  return (
    <div className="progress-track">
      <div className="progress-fill" style={{ width: `${Math.min(100, value * 100).toFixed(0)}%`, background: color }} />
    </div>
  )
}

export default function ReminderCard({ state: s }: Props) {
  const { rule: r, status } = s
  const cls = `reminder-card status-${status}`

  const kmText = s.remainingKm != null
    ? s.remainingKm <= 0
      ? `逾期 ${Math.abs(s.remainingKm).toLocaleString()} km`
      : `剩 ${s.remainingKm.toLocaleString()} km`
    : null

  const dayText = s.remainingDays != null
    ? s.remainingDays <= 0
      ? `逾期 ${Math.abs(s.remainingDays)} 天`
      : `剩 ${s.remainingDays} 天`
    : null

  return (
    <div className={cls}>
      <div className="rc-top">
        <span className="rc-name">{r.name}</span>
        {r.category && <span className="rc-cat">{r.category}</span>}
        <span className={`rc-badge badge-${status}`}>
          {status === 'overdue' ? '已逾期' : status === 'warning' ? '即將到期' : '正常'}
        </span>
      </div>

      <div className="rc-meta">
        {kmText  && <span>{kmText}</span>}
        {dayText && <span>{dayText}</span>}
        {s.dueKm   && <span>到期里程 {s.dueKm.toLocaleString()} km</span>}
        {s.dueDate && <span>到期日 {s.dueDate.replace(/-/g, '/')}</span>}
      </div>

      {s.progressKm   != null && <ProgressBar value={s.progressKm}   status={status} />}
      {s.progressDays != null && <ProgressBar value={s.progressDays} status={status} />}
    </div>
  )
}
